import { Component, OnInit } from '@angular/core';
import { ActivosService } from '../activos.service';
import { Activo } from '../../../../core/modelos/activo';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '../../../../core/animations';
import { NotificacionesService } from '../../../../core/notificaciones/notificaciones.service';

@Component({
    selector: 'fuse-activos-detalle',
    templateUrl: './activos-detalle.component.html',
    styleUrls: ['./activos-detalle.component.scss'],
    animations   : fuseAnimations
})
export class ActivosDetalleComponent implements OnInit {

    activo: Activo;
    idActivo: number;

    formulario: FormGroup;

    constructor(
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private activosService: ActivosService,
        private router: Router,
        private notificaciones: NotificacionesService
    ) {
        // Traigo el activo por parametro
        this.activatedRoute.params.subscribe(params => {
            this.idActivo = params['idActivo'];
            
            // notify about the new activo
            this.activosService.setCurrentActivo(this.idActivo)
        });
    }

    ngOnInit() {

        this.activosService.getActivo(this.idActivo).subscribe(
            data => {
                if (data.success) {
                    this.activo = data.items;
                    this.activo.imagen = this.activo.imagen ? 'data:image/jpeg;base64,' + this.activo.imagen : null;
                    this.crearFormulario();

                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.ActivoNOObtenido);
                    this.router.navigate(['/activos']);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            });

    }

    crearFormulario() {

        this.formulario = this.fb.group({

            'nombre'       : new FormControl({value: this.activo.nombre, disabled: true}),
            'codigo'       : new FormControl({value: this.activo.codigo, disabled: true}),
            'ciudad'       : new FormControl({value: this.activo.ciudad, disabled: true}),
            'direccion'    : new FormControl({value: this.activo.direccion, disabled: true}),
            'estado'       : new FormControl({value: this.activo.estado.nombre, disabled: true}),
            'enlace'       : new FormControl({value: this.activo.enlace, disabled: true}),
            'latitud'      : new FormControl({value: this.activo.latitud, disabled: true}),
            'longitud'     : new FormControl({value: this.activo.longitud, disabled: true}),
            'sector'       : new FormControl({value: this.activo.sector.nombre, disabled: true}),
            'tipologia'    : new FormControl({value: this.activo.tipologia.nombre, disabled: true}),
            'kpis'         : new FormControl({value: this.activo.kpis, disabled: true}),
            'sociedad'     : new FormControl({value: this.activo.sociedad, disabled: true}),
            'descripcion'  : new FormControl({value: this.activo.descripcion, disabled: true}),
        });

    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/activos/detalle/activos-detalle.component.ts